import { useEffect, useState } from 'react'
import allLocales from '@fullcalendar/core/locales-all'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import { useTranslation } from 'react-i18next'
import styles from './Calendar.module.scss'

export const Calendar = (props) => {
  const { events } = props
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language
  const [eventsFormat, setFormatEvents] = useState([])
  const [loading, setLoading] = useState(false)

  const formatEvents = () => {
    setLoading(true)
    const result = []
    if (events?.length) {
      for (let i = 0; i < events.length; i++) {
        const event = events[i]
        const translatedTitle = event.name[currentLanguage]

        result.push({
          ...event,
          title: translatedTitle,
          start: event.openDate,
          end: event.closeDate,
        })
      }
    }
    setFormatEvents(result)
    setLoading(false)
  }

  useEffect(() => {
    formatEvents()
  }, [events, currentLanguage])

  if (loading) {
    return (
      <div>
        <span>Loading...</span>
      </div>
    )
  }

  return (
    <div className={styles['calendar-styles']}>
      <FullCalendar
        locales={allLocales}
        locale={currentLanguage}
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek',
        }}
        initialView='dayGridMonth'
        editable={false}
        selectable={true}
        weekends={true}
        events={eventsFormat}
        eventClick={(e) => {
          props.onSelectEvent({ ...e.event._def.extendedProps, id: e.event._def.extendedProps._id })
        }}
      />
    </div>
  )
}
